// extracted by mini-css-extract-plugin
export default {"container":"Jm-z","bubbleNav":"Km-z","graphic":"Lm-z","contact":"Mm-z"};